// extracted by mini-css-extract-plugin
export var contact = "OurLeadershipCard-module__contact___y5ChW";
export var pronouns = "OurLeadershipCard-module__pronouns___p9XgY";
export var title = "OurLeadershipCard-module__title___MK5t7";
export var name = "OurLeadershipCard-module__name___tMyPq";
export var modal = "OurLeadershipCard-module__modal___gciNU";
export var card = "OurLeadershipCard-module__card___yd1aT";
export var img = "OurLeadershipCard-module__img___kYLK7";
export var bio = "OurLeadershipCard-module__bio___erqWP";